import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AppInjector } from "../injectors";
import {
    AuthenticatedUser,
    AuthenticateUser,
    AuthenticationResetModel,
    ResetLinkModel,
    AuthenticationModel,
    ChangePasswordModel, UsageConditionsModel, SupplierUserBasicModel
} from "./auth.model";
import { MessagesComponent } from "../components";

export class Auth {

    static user: AuthenticatedUser;
    static actions: boolean[] = [];
    static isAuthenticated: boolean = false;
    static isAuthenticatedCondition: boolean = false;
    static init(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.getAuthenticatedUser().then(() => {
                resolve();
            });
        });
    }

    static Authenticate(credentials: AuthenticationModel): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.post(`${environment.apiUrl}/Authentication/Login`, credentials).toPromise().then((data) => {
                this.init().then(() => {
                    resolve();
                })
            }).catch((e: any) => {
                reject(e);
            })
        });
    }


    static Login(credentials: AuthenticationModel): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.post(`${environment.apiUrl}/User/Login`, credentials).toPromise().then((data) => {

                let router = AppInjector.instance.get<Router>(Router);
                if (data['supplierUser']) {
                    this.user = data['supplierUser'];
                    let words = data['supplierUser']['name'].split(' ');
                    let firstName = words[0];
                    let lastName = words[1];
                    this.user.firstName = firstName;
                    this.user.lastName = lastName;
                }

                if (data['supplierUserLoginStatusName'] == 'ChangePsw') {
                    router.navigate(['/change-password']);
                }
                else if (data['supplierUserLoginStatusName'] == 'WrongInputParameters' || data['supplierUserLoginStatusName'] == "WrongUserNamePsw") {

                    MessagesComponent.instance.showError([data['message']]);
                }
                else if (data['supplierUserLoginStatusName'] == 'UserConditionAcceptanceUndefined') {
                    this.isAuthenticatedCondition = false;
                    router.navigate(['/usage-conditions']);
                }
                else {
                    this.isAuthenticatedCondition = true;
                    this.isAuthenticated = true;
                    router.navigate(['/home']);
                }
                resolve();
            }).catch((e: any) => {
                reject(e);
            })
        });
    }



    static changePassword(credentials: ChangePasswordModel): Promise<any> {
        let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
        return httpClient.post(`${environment.apiUrl}/User/ChangePassword`, credentials).toPromise();

    }

    static getUsageConditions(): Promise<UsageConditionsModel> {
        let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
        return httpClient.get<UsageConditionsModel>(`${environment.apiUrl}/User/GetUsageConditions`).toPromise();
    }


    static saveUsageConditions(conditionsDocumentId: number): Promise<any> {
        let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
        let cond = { 'supplierUserId': this.user.id, 'conditionsDocumentId': conditionsDocumentId };
        return httpClient.post(`${environment.apiUrl}/User/SaveUsageConditions`, cond).toPromise();
    }

    static isAuthorized(action: string): boolean {
        return this.isAuthenticated && this.actions[action];
    }

    static isPresentImage(): boolean {
        if (this.user) {

            return this.user.isPresentImage;
        } else {

            return false;
        }
    }

    static checkAuthorization(action: string) {
        if (!this.isAuthorized(action)) {
            let router = AppInjector.instance.get<Router>(Router);
            router.navigate(['/unauthorized']);
        }
    }

    static authenticate(user: AuthenticateUser): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.post(`${environment.apiUrl}/Authentication/Authenticate`, user).toPromise().then(() => {
                this.init().then(() => {
                    resolve();
                })
            });
        });
    }

    static getAuthenticatedUser(): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.get(`${environment.apiUrl}/User/AuthenticatedUser`).toPromise().then((item: any) => {

                if (item) {
                    this.user = new AuthenticatedUser();
                    this.user.id = item.id;

                    let words = item.firstName.split(' ');
                    let firstName = words[0];
                    let lastName = words[1];
                    this.user.firstName = firstName;
                    this.user.lastName = lastName;
                    this.user.role = item.roleName;
                    this.user.supplierId = item.supplierId;
                    this.user.isPresentImage = false;
                    this.CreateImage(item.photo, item.mimeType);

                    this.CheckSupplierUserStatusForUserConditionAcceptance(this.user.id).then((item: any) => {
                        this.isAuthenticatedCondition = item;
                        this.isAuthenticated = true && this.isAuthenticatedCondition;
                    })

                } else {
                    this.user = undefined;
                    this.isAuthenticated = false;
                }

                resolve();
            });
        });
    }

    private static CreateImage(photo: string, type: string) {
        if (photo && type) {
            if (this.user) {
                const typeLower = type.toLocaleLowerCase();
                const imgFormat = `data:image/${typeLower};base64,${photo}`;
                this.user.photoimg = imgFormat;
                this.user.isPresentImage = true;

            }
        }
    }

    private static getAuthenticatedUserActions(): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.get(`${environment.apiUrl}/Authentication/AuthenticatedUserActions`).toPromise().then((actions: string[]) => {

                for (let prop in this.actions) {
                    this.actions[prop] = false;
                }

                if (actions) {
                    actions.forEach(s => {
                        this.actions[s.toUpperCase()] = true;
                    })
                }

                resolve();
            });
        });
    }

    public static getActions(): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.get(`${environment.apiUrl}/Authentication/Actions`).toPromise().then((actions: string[]) => {

                for (let prop in this.actions) {
                    this.actions[prop] = false;
                }

                if (actions) {
                    actions.forEach(s => {
                        this.actions[s.toUpperCase()] = false;
                    })
                }

                resolve();
            });
        });
    }

    static sendResetPassword(credentials: ResetLinkModel) {
        let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
        return httpClient.post<void>(`${environment.apiUrl}/Authentication/SendResetPassword`, credentials).toPromise();
    }

    static resetPassword(credentials: AuthenticationResetModel) {
        let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
        return httpClient.post<void>(`${environment.apiUrl}/Authentication/ResetPassword`, credentials).toPromise();
    }

    static getNotFirstLoginUsers(): Promise<SupplierUserBasicModel[]> {
        let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
        return httpClient.get<SupplierUserBasicModel[]>(`${environment.apiUrl}/Authentication/NotFirstLoginUsers`).toPromise();
    }

    static logOut(): Promise<void> {
        return new Promise((resolve, reject) => {
            let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
            httpClient.get<void>(`${environment.apiUrl}/User/Logout`).toPromise().then(() => {
                Auth.isAuthenticated = false;
                Auth.user = undefined;
                this.init().then(() => {
                    resolve();
                })

            });
        });
    }

    static CheckSupplierUserStatusForUserConditionAcceptance(id: number) {
        let httpClient = AppInjector.instance.get<HttpClient>(HttpClient);
        return httpClient.get<void>(`${environment.apiUrl}/User/CheckSupplierUserStatusForUserConditionAcceptance/` + id).toPromise();
    }
}
